"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 35 35", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M17.5 0C7.835 0 0 7.835 0 17.5S7.835 35 17.5 35 35 27.165 35 17.5 27.165 0 17.5 0z", fill: fill }),
            react_1.default.createElement("path", { fill: "#FFF", d: "M26.6 27.252l-.151.848h-6.833l.137-.824 1.596-.357-.468-4.56h-2.063L18.02 28.1h-.962l.852-5.741H16.7l-.798 5.741h-.963l.853-5.741h-2.31l-2.324 4.388 2.275.456-.15.897H7l.136-.834 1.995-.452L21.127 5H22.4l2.685 21.848z" }),
            react_1.default.createElement("path", { d: "M20.65 20.75L19.588 10.6 14 20.75h1.816l.28-1.836c.167-1.133.866-1.565 1.704-1.565 1.09 0 1.565.729 1.565 1.322 0 .783-.531 1.404-1.481 1.404-.391 0-.727-.135-1.006-.35l-.168 1.025h3.94z", fill: fill }))));
};
var Sa = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#005693' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill, shift: -5 }, rest));
};
exports.default = Sa;
